export default __webpack_public_path__ + "static/media/calendra.a7b0afff.svg";